import * as z from 'zod';

export const AddBrandSchema = z.object({
  brandName: z
    .string()
    .min(3, 'Min 3 characters required')
    .max(40, 'Max 40 characters allowed')
    .regex(/^[a-zA-Z\s'-]+$/, 'Invalid characters used')
    .trim()
    .refine(val => val.length > 0, {
      message: 'Name cannot be just whitespace',
    }),
  description: z.string().min(3, 'Min 3 characters required'),
  imageUrl: z.string().optional(),
  id: z.string().optional(),
  keyword: z.string().optional(),
  origin: z.string().optional(),
  status: z.boolean().optional(),
});

export type AddBrandSchemaT = z.infer<typeof AddBrandSchema>;
